<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mt-5">
      <img
          src="https://dsrjp3mi03jix.cloudfront.net/news.jpg" alt="Logo">
    </div>
  </div>

</template>

<script>
import moment from "moment/moment";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'LandingPage',
  created() {
    if(this.getCurrentlySelectedMonth() === undefined){
      this.initializeCurrentlySelectedMonth(moment());
    }
  },
  methods: {
    ...mapGetters({
      getCurrentlySelectedMonth: "time/currentlySelectedMonth",
    }),
    ...mapMutations({
      initializeCurrentlySelectedMonth: "time/initializeCurrentlySelectedMonth",
    }),
  }
};
</script>

<style scoped>
img {
  max-width: 50%;
}

.container {
  display: flex;
}
</style>